export const APP_VERSION_CODE = 10278;
export const APP_VERSION_NAME = "1.2.78";
